import {
  SET_NOTIFICATION,
} from './reducer';

export const setNotification = (notification) => (dispatch) => {
  const payload = {
    notification,
  };
  dispatch({
    type: SET_NOTIFICATION,
    payload,
  });
};
